import * as THREE from "three";

const variables = {
    plane_text: 'adventures in foam',
    gravity:false,
    // particles: {
    //     _diameter: {
    //         params: {
    //             type: 'float-special',
    //             min: 0.1,
    //             max: 3,
    //             increment: 0.1,
    //             float: 1.0
    //         }
    //     },
    //     _speed: {
    //         params: {
    //             type: 'float-special',
    //             min: 0.00001,
    //             max: 1,
    //             increment: 0.001,
    //             float: 0.001
    //         }
    //     },
    //     attenuation: 0.01,
    //     deviation: 4,
    //     re_designation_rate: 200,
    //     _count: {
    //         "params": {
    //             "type": "array-special",
    //             "select": [8, 16, 27, 64, 125, 216],
    //             "index": 0,
    //             "max": 64
    //         }
    //     },
    // },
    _evt_reactivity: {
        params: {
            type: 'float-special',
            min: 10,
            max: 400,
            increment: 10,
            float: 200.0
        }
    },
    point_count: 0,
    render_frame: 0,
    fps: 0.0,
    cam: {
        //base_pos: new THREE.Vector3(0, 10, 15),
        base_pos: new THREE.Vector3(0, 5, 10),
        pos: new THREE.Vector3(0, 0, 0),
    },

    view: {
        start_user_pos: new THREE.Vector3(0, 0, 0),
        helper_color: 0x101010,
        scene_width: 40,
        width: null,
        height: null,
        zooms:true,
        colors: {
            window_background: 0x1D2733,
            window_background_hex: '#1D2733',
        },
        show_grid: true,
        show_axes: false,
        show_bounds: true,
        show_user: true,
        show_plane: true
    },
    paused: false,
}

export {variables};